module.exports = __webpack_public_path__ + "img/loading-circle.21630a51.svg";